import { FC, createContext, useState, useContext } from "react";
import * as _ from "lodash";

import { getStorageKey } from "../../../../../utils/versioning";

/**
 * Onboarding visited modules local storage key
 */
export const onboardingLocalStorageKey = `${getStorageKey()}.onboarding`;

type ContextType = {
  onboardedModules: Record<string, boolean>;
  setOnboardedModules: (value: Record<string, boolean>) => void;
};

/**
 * Default Onboarding context
 */
const DefaultContext = createContext<ContextType>({
  onboardedModules: {},
  setOnboardedModules: _.noop
});

const _OnboardingProvider: FC = ({ children }) => {
  const [onboardedModules, _setOnboardedModules] = useState<Record<string, boolean>>(
    JSON.parse(localStorage.getItem(onboardingLocalStorageKey) as string) || {}
  );

  /**
   * Set visited onboarding modules and save to localstorage
   * @param value
   */
  const setOnboardedModules = (value: Record<string, boolean>) => {
    _setOnboardedModules(value);
    localStorage.setItem(onboardingLocalStorageKey, JSON.stringify(value));
  };

  return (
    <DefaultContext.Provider value={{ onboardedModules, setOnboardedModules }}>
      {children}
    </DefaultContext.Provider>
  );
};

export const OnboardingContext = {
  Provider: _OnboardingProvider,
  Consumer: DefaultContext.Consumer
};

/**
 * Hook for onboarding context
 * @returns
 */
export const useOnboarding = (): ContextType => useContext<ContextType>(DefaultContext);
